import CustomStore from 'devextreme/data/custom_store';
import 'whatwg-fetch';
import axiosHttp from '../apps/interceptors/axios-interceptor';
import { useAuth } from '../apps/auth/auth-provider/auth-provider';

function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== '';
}

export function datagridCustomStore(selectedKey, api, dateFilter=[], format='',
  apiKey=''
){  
  let theAPI = api;
  const token = localStorage.getItem('token')
  const store = new CustomStore({

    key: selectedKey,

      async load(loadOptions) {
        const paramNames = [
          'skip',
          'take',
          'requireTotalCount',
          'requireGroupCount',
          'sort',
          'filter',
          'totalSummary',
          'group',
          'groupSummary',
        ]
        if(dateFilter.length > 0){
          if(loadOptions.filter){
            loadOptions.filter.push('and');
            loadOptions.filter.push(dateFilter);            
          } else {
            loadOptions['filter'] = dateFilter;
               
          }
        }
        console.log('loadOptions: ', loadOptions);
        const queryString = paramNames
          .filter((paramName) => isNotEmpty(loadOptions[paramName]))
          .map((paramName) => `${paramName}=${JSON.stringify(loadOptions[paramName])}`)
          .join('&');
        try {
          if (format.length > 0){
            theAPI = `${api}?listType=${format}&${queryString}`
          } else {
            theAPI = `${api}?${queryString}`
          }
          console.log('params: ', queryString)
          const response = await fetch(
            `${theAPI}?listType=${format}&${queryString}`, {
              headers: {Authorization: `Bearer ${token}`,
              'Api-Key': apiKey,
            }
            }
          );
          const result = await response.json();
          return {
            data: result.data,
            totalCount: result.totalCount,
          };
        } catch (err) {
          throw new Error('Data Loading Error');
        }
      },
      async byKey(selectedKey) {
        // const auth = useAuth();
        const token = localStorage.getItem('token')
        const headers = { 
          headers: new Headers({
              'Authorization': `Bearer ${token}`, 
          })
        }
        const response = await fetch(`${api}${selectedKey}/`, headers);
        if (!response.ok) {
          throw new Error('Failed to fetch data');
      }
  
      return await response.json();
      }
    }); 

  return store
}